import React, { useState, useEffect } from "react";
import { FiSettings } from "react-icons/fi";
import { FaSms, FaPhoneAlt, FaCommentAlt, FaWhatsapp } from "react-icons/fa";
import { Link } from "react-router-dom";
import Axios from '../../../axios/Axios';
import { HOST_URL } from '../api/Api';
import styles from "./NotificationDropdown.module.css";

const NotificationDropdown = () => {
  const lStorage = JSON.parse(localStorage.getItem("login"));
  const userId = lStorage.user.userId;
  const userToken = lStorage.token;

  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    fetchNotifications();
    // eslint-disable-next-line
  }, []);

  const fetchNotifications = async () => {
    try {
      const response = await Axios.post(`${HOST_URL}/notification.php`, {
        user_id: userId,
        method: "retrieve",
        token: userToken,
      });

      if (response.data.success) {
        const formatted = response.data.data.map((n) => {
          let remarkData;
          try {
            remarkData = JSON.parse(n.remark);
          } catch {
            remarkData = {};
          }

          return {
            id: n.id,
            title: n.notify_type.replace(/_/g, " "), // user-friendly title
            message: remarkData.message_template_name
              ? `Template: ${remarkData.message_template_name}, Score: ${remarkData.new_quality_score || ""}`
              : n.notify_type,
            time: n.created,
            unread: n.read_status === 0,
            channel: n.channel, // SMS, Voice, RCS, WhatsApp
          };
        });

        setNotifications(formatted);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  const markAllAsRead = () => {
    setNotifications(notifications.map((n) => ({ ...n, unread: false })));
    // TODO: call API to mark all notifications as read if required
  };

  const getIcon = (channel) => {
    switch (channel?.toLowerCase()) {
      case "sms":
        return <FaSms className={`${styles.notifIcon} ${styles.sms}`} />;
      case "voice":
        return <FaPhoneAlt className={`${styles.notifIcon} ${styles.voice}`} />;
      case "rcs":
        return <FaCommentAlt className={`${styles.notifIcon} ${styles.rcs}`} />;
      case "whatsapp":
        return <FaWhatsapp className={`${styles.notifIcon} ${styles.whatsapp}`} />;
      default:
        return <FaWhatsapp className={styles.notifIcon} />; // fallback
    }
  };

  return (
    <div className={styles.notificationDropdown}>
      {/* Header */}
      <div className={styles.dropdownHeader}>
        <h4>Notifications</h4>
        <div className={styles.headerActions}>
          <Link to="/dashboard/notification">
            <FiSettings className={styles.settingsIcon} />
          </Link>
          {/* <button onClick={markAllAsRead} className={styles.markReadBtn}>
            Mark all as read
          </button> */}
        </div>
      </div>

      {/* Notifications list */}
      <div className={styles.dropdownList}>
        {notifications.length === 0 && <p style={{ padding: "10px" }}>No notifications found</p>}
        {notifications.map((n) => (
          <div key={n.id} className={`${styles.notifItem} ${n.unread ? styles.unread : ""}`}>
            {getIcon(n.channel)}
            <div className={styles.notifContent}>
              <div className={styles.notifTitle}>{n.title}</div>
              <div className={styles.notifMessage}>{n.message}</div>
              <div className={styles.notifTime}>{n.time}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Footer */}
      <div className={styles.dropdownFooter}>
        <Link to="/dashboard/view-all-notifications" className={styles.viewAllBtn}>
          View all notifications
        </Link>
      </div>
    </div>
  );
};

export default NotificationDropdown;
